import { useState, useContext, useEffect } from "react";
import { Button, Form, Input, notification, Select } from "antd";
import { Context } from "../../context";

import "./styles.css";
import { Fetch, Patch } from "../../fetch";

import { convertIdToKey } from "../../utils";

const DiscountMessage = () => {
  const { apiUrl, token } = useContext(Context);

  const [counter, setCounter] = useState(0);
  const [movies, setMovies] = useState([]);
  const [series, setSeries] = useState([]);
  const [contentID, setContentId] = useState();

  const [form] = Form.useForm();

  useEffect(() => {
    Fetch(`${apiUrl}/discounts/message?id=${contentID}`, token, (result) => {
      if (result.success === true) {
        form.setFieldValue("message", result.message);
      } else {
        form.resetFields();
      }
    });

    if (movies.length === 0) {
      Fetch(`${apiUrl}/movies`, token, (result) => {
        const movies = convertIdToKey(result.movies);
        setMovies(movies);
      });
    }

    if (series.length === 0) {
      Fetch(`${apiUrl}/series`, token, (result) => {
        const series = convertIdToKey(result.series);
        setSeries(series);
      });
    }
  }, [apiUrl, token, counter, contentID]);

  const handleMessageUpdate = async () => {
    const values = await form.validateFields();

    Patch(
      `${apiUrl}/discounts/message?id=${contentID}&operation=update`,
      token,
      {
        ...values,
        disountMessage: true,
      },
      (result) => {
        if (result) {
          notification.success({
            message: "Success",
            description: "Message Updated",
          });
          form.setFieldValue("message", result["message"]);
          setCounter(counter + 1);
        } else {
          notification.error({
            message: "Failed",
            description: result["message"],
          });
        }
      }
    );
  };

  const handleClearMessage = async () => {
    const values = await form.validateFields();
    Patch(
      `${apiUrl}/discounts/message?operation=clear&id=${contentID}`,
      token,
      {
        ...values,
        disountMessage: true,
      },
      (result) => {
        if (result) {
          notification.success({
            message: "Success",
            description: "Message Cleared",
          });
          setCounter(counter + 1);
        } else {
          notification.error({
            message: "Failed",
            description: result["message"],
          });
        }
      }
    );
  };

  return (
    <div>
      <Select
        placeholder="Select Content"
        mode="single"
        style={{ width: "300px", marginLeft: "1%" }}
        onSelect={(v) => setContentId(v)}
      >
        {movies
          .filter((doc) => doc.model === "ticket")
          .map((doc) => (
            <Select.Option key={doc.key} value={doc.key}>
              {doc.title}{" "}
            </Select.Option>
          ))}
        {series
          .filter((doc) => doc.model === "ticket")
          .map((doc) => (
            <Select.Option key={doc.key} value={doc.key}>
              {doc.title}{" "}
            </Select.Option>
          ))}
      </Select>
      <div className="message-input-wrapper">
        <Form form={form}>
          <Form.Item name={"message"} noStyle>
            <Input.TextArea
              showCount
              maxLength={300}
              placeholder="Enter message to display"
            />
          </Form.Item>
        </Form>
        <div className="buttons-container">
          <div></div>
          <div className="buttons-div">
            <Button className="message-submit-btn" onClick={handleClearMessage}>
              Clear
            </Button>
            <Button
              className="message-submit-btn"
              type="primary"
              onClick={handleMessageUpdate}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountMessage;
